var angular = require('angular');
var template = require('./public-banner.pug');

angular.module("app.directives")
  .directive('publicBanner', function () {
  return {
    restrict: 'E',
    replace: true,
    template:  require("./public-banner.pug"),
    transclude: true,
    link: function (scope) {
      var bannerConfig = window.conf.public_banner;
      if (bannerConfig){
        scope.display = bannerConfig.message 
                          && (!bannerConfig.start || new Date(bannerConfig.start) < new Date())
                          && (!bannerConfig.end || new Date(bannerConfig.end) > new Date())
      }
      if (scope.display){
        scope.message = bannerConfig.message;
      }
    }
  }
});
